import { attr } from '@ember-data/model';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  marginBasisPoints: attr('number'),
  marginCents: attr('money-proto'),
  equals(other) {
    if (other === null) {
      return false;
    }
    return this.marginBasisPoints === other.get('marginBasisPoints');
  }
}).reopenClass({
  _modelNameForMigration: 'interchange-plus-processing-fee'
});